import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import "./css/EnrollmentKit.css";
import { useQuery, gql } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";
import parse from "html-react-parser";
import { useDispatch, useSelector } from "react-redux";
import { addItemToCart, setAssociateId, setToken } from "../slices/signUp";
import { getCall, postCall } from "../utils/Network";
import { useTranslation } from "react-i18next";
import { removeItemFromCart } from "../slices/signUp";
import countries from "../utils/countries_states.json";
import scrollToTop from "../components/hooks/ScrollToTop";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import Slider from "react-slick";
import "./css/Review.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { setAddOnIds, setProducts } from "../slices/productSlice";
import { flagEnabled } from "../utils/flag";
import ProgressBar from "../components/ProgressBar";
import { useGetProducts } from "../hooks/getProducts";

const ApiKey = process.env.REACT_APP_API_KEY;
const BaseApiUrl = process.env.REACT_APP_API_URL;

function useQuery1() {
  return new URLSearchParams(useLocation().search);
}

var GET_DATA = gql`
  query ($localIds: [String]) {
    regions(localIds: $localIds) {
      id
      name
    }
  }
`;

var GET_PRODUCTS = gql`
  query (
    $offset: Int!
    $first: Int!
    $search: String!
    $StoreId: [String]!
    $regionIds: [String]!
    $customerType: [String]!
    $currencyCode: [String]!
  ) {
    products(
      offset: $offset
      first: $first
      search: $search
      storeIds: $StoreId
      customerTypes: $customerType
      regionIds: $regionIds
      currencyCodes: $currencyCode
    ) {
      id

      name

      displayIndex

      imageUrl

      enabled
      categories {
        name
        __typename
      }

      description
      specifications
      customData

      prices {
        id

        price

        priceCurrency

        volume {
          volumeId

          volume
        }
      }
    }
  }
`;

// EnrollmentKit component

export default function EnrollmentKit() {
  const { t } = useTranslation();
  const query = useQuery1();
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [userData, setUserData] = useState({});
  // const associationResponse = useSelector((state) => state.signup.associateId);
  const associateId = useSelector((state) => state.signup.associateId);
  const associateIdFromQuery = query.get("associateId");
  const tokenFromQuery = query.get("token");
  const itemIdFromQuery = sessionStorage.getItem("itemIdFromQuery");
  useEffect(() => {
    if (associateIdFromQuery && tokenFromQuery) {
      const decodedId = atob(associateIdFromQuery);
      const decodedToken = atob(tokenFromQuery);
      console.log("token", decodedToken);

      localStorage.setItem("associateId", decodedId);
      sessionStorage.setItem("associateId", decodedId);
      dispatch(setAssociateId(decodedId));

      localStorage.setItem("token", decodedToken);
      sessionStorage.setItem("token", decodedToken);
      dispatch(setToken(decodedToken));
    }
  }, [associateIdFromQuery, tokenFromQuery]);

  // const addOnItemsCallId = selectedProduct.map((item) => item.id);

  const associationResponse = associateId ?? associateIdFromQuery;

  const token = useSelector((state) => state.signup.token);
  const [localId, setLocalId] = useState([]);
  const [regionId, setRegionId] = useState(null);
  const {
    products: allProducts,
    fetchProducts,
    error,
    loading: productsLoading,
  } = useGetProducts();
  const [isLoading, setIsLoading] = useState(false);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [addOnItems, setAddOnItems] = useState([]);
  const dispatch = useDispatch();
  const [expandedStates, setExpandedStates] = useState({});
  const navigate = useNavigate();
  const params = useParams();

  // toggle height
  const toggleDescription = (id) => {
    setExpandedStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  // slider settings
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 2,
    arrows: true,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleOptionSelect = (productId, optionKey) => {
    console.log(productId, optionKey, "selection");
    setSelectedOptions((prev) => ({
      ...prev,
      [productId]: optionKey,
    }));
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 550) {
        setIsMobileDevice(false);
      } else {
        setIsMobileDevice(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cart = useSelector((state) => state.signup.cart);

  const totalItemsInCart = Object.values(cart).reduce(
    (total, item) => total + item.quantity,
    0,
  );

  const constructLocalId = (shippingAddress) => {
    if (shippingAddress?.countryCode && shippingAddress?.state) {
      // Extract country code and state to build the local ID
      const countryCode = shippingAddress.countryCode.toLowerCase();
      const stateCode = shippingAddress.state.slice(0, 2).toLowerCase(); // Or use any mapping logic if required
      return `${countryCode}-${stateCode}`;
    }
    return null;
  };

  const fetchItems = async () => {
    try {
      const myHeaders = { "API-key": ApiKey, Authorization: "Bearer " + token };
      console.log(myHeaders);

      const cartItemIDs = JSON.parse(sessionStorage.getItem("cart") || "{}");

      const addOnItemsCallId =
        Object.values(cartItemIDs).map((item) => item.id) ||
        selectedProduct.map((item) => item.id);

      const queryParams = new URLSearchParams();
      addOnItemsCallId.forEach((id) => {
        queryParams.append("ItemIds", id);
      });

      const response = await getCall({
        fullUrl: `${BaseApiUrl}/api/v1/Subscription/GetAddOnItems?${queryParams.toString()}`,
        header: myHeaders,
      });

      const items = response?.data || [];
      setAddOnItems(items);
      dispatch(setAddOnIds(items));
      sessionStorage.setItem("addOnItem", JSON.stringify(items));

      return items;
    } catch (error) {
      console.error("Error fetching Add-On items:", error);
      setAddOnItems([]);
      dispatch(setAddOnIds([]));
      sessionStorage.removeItem("addOnItem");
      return [];
    }
  };

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    fetchAssociateData();
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/js/webflow.schunk.802e45714a4e6196.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  sessionStorage.setItem("regionId", regionId);

  // const Products = useQuery(GET_PRODUCTS, {
  //   variables: {
  //     offset: 0,
  //     first: 100,
  //     search: "",
  //     StoreId: ["4"],
  //     regionIds: [regionId?.toString()],
  //     customerType: ["3"],
  //     currencyCode: ["USD"],
  //   },
  //   skip: !regionId,
  // });

  useEffect(() => {
    if (regionId && userData?.userTypeId) {
      fetchProducts({
        regionId,
        userType: userData.userTypeId,
        token: token || tokenFromQuery,
      });
    }
  }, [regionId, userData]);

  const transformProducts = (products) => {
    const productMap = products.reduce((map, product) => {
      map[product.id] = product;
      return map;
    }, {});

    let finalProducts = [];
    let removeProducts = [];
    products.forEach((product) => {
      const attributes =
        typeof product.customData === "string"
          ? JSON.parse(product.customData)
          : product.customData || {};
      if (attributes?.Type?.toLowerCase() === "main") {
        const updatedCustomData = { ...attributes };

        Object.keys(attributes).forEach((weekKey) => {
          const childId = attributes?.[weekKey];
          if (childId && productMap?.[childId]) {
            updatedCustomData[weekKey] = productMap[childId];
            // Flag the products to be removed from the list
            removeProducts.push(childId);
          }
        });

        finalProducts.push({
          ...product,
          customData: updatedCustomData,
        });
      } else {
        finalProducts.push(product);
      }
      // Ignore Type === "Sub" at root level
    });
    // Remove the child products from the final list
    if (removeProducts.length > 0) {
      finalProducts = finalProducts.filter(
        (product) => !removeProducts.includes(product.id),
      );
    }

    if (finalProducts) {
      finalProducts = [...finalProducts]
        .sort((x, y) => x.displayIndex - y.displayIndex)
        .filter(
          (item) =>
            item.enabled &&
            item.prices.length > 0 &&
            !item.categories?.some((c) => c.name?.toLowerCase() === "add on"),
        );
    }
    return finalProducts;
  };
  const apiResponse = allProducts || [];

  const normalizedProducts = useMemo(() => {
    let products = transformProducts(apiResponse);

    if (itemIdFromQuery) {
      const filtered = products.filter(
        (p) => String(p.id) === String(itemIdFromQuery),
      );

      return filtered.length ? filtered : products; // fallback
    }

    return products;
  }, [apiResponse, itemIdFromQuery]);

  dispatch(setProducts(apiResponse));

  // Fetch Associate Function
  const fetchAssociateData = async () => {
    setIsLoading(true);
    const id = associationResponse;
    const myHeaders = { "API-key": ApiKey };

    const response = await getCall({
      url: "getAssociate",
      urlParams: { associateid: id },
      header: myHeaders,
    });
    if (response?.data) {
      setUserData(response?.data);
      sessionStorage.setItem("enroller", JSON.stringify(response.data));

      let countrycode = response.data?.billingAddress?.countryCode || "";

      let reg = await getCall({
        url: "getRegion",
        urlParams: { countryCode: countrycode, stateCode: "all" },
        header: { Authorization: "Bearer " + token || tokenFromQuery },
      });

      if (reg.data && reg.data.regionId) {
        setRegionId(reg.data.regionId);
      } else {
        setRegionId(2);
      }

      const shippingAddress = response.data.billingAddress;

      const localIdValue = constructLocalId(shippingAddress);
      if (localIdValue) {
        setLocalId([localIdValue]); // Update state with LocalId
      }
    }
    setIsLoading(false);
  };

  // Add to Cart Function
  const addToCart = (product) => {
    dispatch(addItemToCart(product));
  };
  // Handle Add To Cart Function
  const handleAddToCart = (product) => {
    if (
      !product ||
      !product.prices ||
      product.prices.length === 0 ||
      product.prices[0].price == null
    ) {
      toast.error("This product does not have a valid price.");
      return;
    }
    let currentProduct = selectedProduct.filter((p) => {
      return p.id === product.id;
    });

    if (currentProduct.length === 0 && product?.prices[0]?.price != null) {
      let store = [...selectedProduct, product];
      setSelectedProduct(store);
      addToCart({
        id: product.id,
        name: product.name,
        price: product.prices[0].price,
      });
    }
  };

  // Remove From Cart Function
  const removeFromCart = (itemId) => {
    setSelectedProduct(
      selectedProduct.filter((p) => {
        return p.id !== itemId;
      }),
    );
    dispatch(removeItemFromCart({ id: itemId }));
  };

  const fnReview = () => {
    if (totalItemsInCart > 0) {
      Navigate(`/${params.enrollerCode}/review`);
    }
  };

  const fnBack = () => {
    Navigate(`/${params.enrollerCode}/enrollment-kit`);
  };

  const checkKeyPress = (e) => {
    if (e?.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const fnNavigate = async () => {
    try {
      const isFlagEnabled = flagEnabled("ADD_ON_PAGE");

      if (isFlagEnabled) {
        const items = await fetchItems();

        if (items && items.length > 0) {
          navigate(`/${params.enrollerCode}/addOn`);
          return;
        }
      }

      navigate(`/${params.enrollerCode}/review`);
    } catch (error) {
      console.error("Error during navigation:", error);
      navigate(`/${params.enrollerCode}/review`);
    }
  };

  return (
    <>
      {productsLoading || (isLoading && <Loader />)}
      <div className="theme-bg">
        <div className="enrollment-navbar">
          <div className="noa-logo heading-margin"></div>
          <div style={{ display: "flex" }}>
            <button onClick={fnNavigate} className="cartButton">
              <img
                src="/images/cart.png"
                loading="lazy"
                alt=""
                style={{ width: "40px", height: "40px", padding: "0.3rem" }}
              />
              <span aria-label="cart">
                <b>{isMobileDevice ? "" : t("cart")}</b>
              </span>
              {totalItemsInCart > 0 && (
                <span
                  className="basket-count"
                  style={{ top: "-5px", right: "-5px" }}
                >
                  {totalItemsInCart}
                </span>
              )}
            </button>
          </div>
        </div>
        <div className="enrollment-kit-page">
          <ProgressBar currentStep={"2"} />

          <div className="heading">
            <h2 style={{ color: "white", fontSize: "1.9rem" }}>
              {t("enrollmentKits")}
            </h2>
          </div>

          <div className="kits-div white">
            {normalizedProducts?.length > 0 ? (
              <>
                {/* mobile view code  */}

                {isMobileDevice ? (
                  <>
                    {normalizedProducts.map((item, index) => {
                      const optionKey = selectedOptions[item.id] || "main";
                      const displayedProduct =
                        optionKey === "main"
                          ? item
                          : item.customData?.[optionKey];
                      if (!displayedProduct) return null;
                      const perMonthLabel =
                        !optionKey || optionKey === "main"
                          ? t("perMonth")
                          : `/ ${t(optionKey).replace(/-/g, " ")}`;

                      return (
                        <div
                          className="main-kit-card-div"
                          key={displayedProduct.id}
                          style={{ animationDelay: `${index * 0.2}s` }}
                        >
                          <div
                            className={`kit-card ${
                              cart[displayedProduct.id] ? "addedCart " : ""
                            }`}
                            key={displayedProduct.id}
                          >
                            <div className="card-upper">
                              <div className="name-price-img-div">
                                <div className="img-div">
                                  <img
                                    src={
                                      displayedProduct.imageUrl
                                        ? displayedProduct.imageUrl.includes(
                                            "http",
                                          )
                                          ? `${displayedProduct.imageUrl}`
                                          : `https://sqlvaqdxcel5sg4jky.blob.core.windows.net/documentstorage/${displayedProduct.imageUrl}`
                                        : "/images/noimage.jpg"
                                    }
                                  />
                                </div>
                                <div className="name-div">
                                  <p className="product_name">
                                    {displayedProduct.name}
                                  </p>
                                </div>
                              </div>
                              <div className="price-div">
                                <p className="price-value">
                                  {displayedProduct.prices[0]
                                    ? `$${displayedProduct.prices[0].price}`
                                    : ""}
                                </p>
                                <p>{perMonthLabel}</p>
                              </div>

                              {item.customData?.Type &&
                                item.customData?.Type.toLowerCase() ===
                                  "main" && (
                                  <div className="month-options">
                                    {/* Main Option */}
                                    <div className="option-button-wrapper">
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleOptionSelect(item.id, "main");
                                        }}
                                        className={`option-button ${
                                          optionKey === "main" ? "active" : ""
                                        }`}
                                      >
                                        <span className="option-text">
                                          {t("base")}
                                        </span>
                                      </a>
                                    </div>

                                    {/* Other Options */}
                                    {Object.keys(item.customData)
                                      .filter(
                                        (key) =>
                                          key !== "Type" && key !== "Main",
                                      )
                                      .map((key) =>
                                        item.customData[key] &&
                                        item.customData[key].id ? (
                                          <div
                                            key={key}
                                            className="option-button-wrapper"
                                          >
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleOptionSelect(
                                                  item.id,
                                                  key,
                                                );
                                              }}
                                              className={`option-button ${
                                                optionKey === key
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              <span className="option-text">
                                                {key}
                                              </span>
                                            </a>
                                          </div>
                                        ) : null,
                                      )}
                                  </div>
                                )}
                            </div>

                            <div className="card-lower">
                              {/* description*/}
                              <div className="description-div">
                                {parse(
                                  displayedProduct.description
                                    ? displayedProduct.description
                                    : " ",
                                )}
                              </div>
                              <div
                                className={`specifications-div ${
                                  displayedProduct.specifications
                                    ? ""
                                    : "display-none"
                                }`}
                              >
                                {parse(
                                  displayedProduct.specifications
                                    ? displayedProduct.specifications
                                    : "",
                                )}
                              </div>

                              <div className="btn-div cartbtn">
                                {cart[displayedProduct.id] ? (
                                  <div
                                    className="primary-button-border-wrap"
                                    style={{ width: "100%", cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      removeFromCart(displayedProduct.id);
                                    }}
                                  >
                                    <div className="inner-button-wrap">
                                      <div className="inner-button-text-wrap">
                                        <div className="inner-button-text">
                                          {t("removeFromCart")}
                                        </div>
                                        <div className="inner-button-hover-text">
                                          {t("removeFromCart")}
                                        </div>
                                      </div>
                                      <div className="inner-button-star-wrap">
                                        <img
                                          loading="lazy"
                                          src="/images/inner-button-star-1.svg"
                                          alt=""
                                          className="inner-button-star _1"
                                        />
                                        <img
                                          loading="lazy"
                                          src="/images/inner-button-star-2.svg"
                                          alt=""
                                          className="inner-button-star _2"
                                        />
                                        <img
                                          loading="lazy"
                                          src="/images/inner-button-star-3.svg"
                                          alt=""
                                          className="inner-button-star _3"
                                        />
                                      </div>
                                      <div className="inner-button-hover-bg"></div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="navbar-button-wrapper">
                                    <div className="primary-button-wrapper">
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          handleAddToCart(displayedProduct);
                                        }}
                                        data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                                        className="primary-button w-inline-block"
                                      >
                                        <div className="primary-button-border-wrap">
                                          <div className="primary-button-wrap">
                                            <div className="primary-button-text">
                                              {t("addToCart")}
                                            </div>
                                            <div className="primary-button-hover-text">
                                              {t("addToCart")}
                                            </div>
                                            <div className="primary-button-hover-bg"></div>
                                          </div>
                                        </div>
                                        <div className="line-wrap">
                                          <div className="primary-line-wrap _1">
                                            <div className="line _1"></div>
                                            <div className="line _2"></div>
                                          </div>
                                          <div className="primary-line-wrap _2">
                                            <div className="line _3"></div>
                                            <div className="line _4"></div>
                                          </div>
                                          <div className="primary-line-wrap _3">
                                            <div className="line _5"></div>
                                            <div className="line _6"></div>
                                          </div>
                                          <div className="primary-line-wrap _4">
                                            <div className="line _7"></div>
                                            <div className="line _8"></div>
                                          </div>
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  // laptop view code
                  <Slider {...settings}>
                    {normalizedProducts.map((item, index) => {
                      const optionKey = selectedOptions[item.id] || "main";
                      const displayedProduct =
                        optionKey === "main"
                          ? item
                          : item.customData?.[optionKey];
                      if (!displayedProduct) return null;

                      const isExpanded =
                        expandedStates[displayedProduct.id] || false;
                      const perMonthLabel =
                        !optionKey || optionKey === "main"
                          ? t("perMonth")
                          : `/ ${t(optionKey).replace(/-/g, " ")}`;

                      return (
                        //  <div className="main-kit-card-div" key={displayedProduct.id} style={{height : '900px'}}>
                        <div
                          className={`kit-card ${
                            cart[displayedProduct.id] ? "addedCart " : ""
                          }`}
                          key={displayedProduct.id}
                        >
                          <div className="card-upper">
                            <div className="name-price-img-div">
                              <div className="img-div">
                                <img
                                  src={
                                    displayedProduct.imageUrl
                                      ? displayedProduct.imageUrl.includes(
                                          "http",
                                        )
                                        ? `${displayedProduct.imageUrl}`
                                        : `https://sqlvaqdxcel5sg4jky.blob.core.windows.net/documentstorage/${displayedProduct.imageUrl}`
                                      : "/images/noimage.jpg"
                                  }
                                />
                              </div>
                              <div className="name-div">
                                <p className="product_name">
                                  {displayedProduct.name}
                                </p>
                              </div>
                            </div>
                            <div className="price-div">
                              <p className="price-value">
                                {displayedProduct.prices[0]
                                  ? `$${displayedProduct.prices[0].price}`
                                  : ""}
                              </p>
                              <p>{perMonthLabel}</p>
                            </div>
                          </div>

                          <div className="card-lower">
                            {/* <div className={`child-card-lower ${isExpanded ? 'expanded' : ''}`}> */}
                            <div className="child-card-lower">
                              {item.customData?.Type &&
                                item.customData?.Type.toLowerCase() ===
                                  "main" && (
                                  <div className="month-options">
                                    {/* Main Option */}
                                    <div className="option-button-wrapper">
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleOptionSelect(item.id, "main");
                                        }}
                                        className={`option-button ${
                                          optionKey === "main" ? "active" : ""
                                        }`}
                                      >
                                        <span className="option-text">
                                          {t("base")}
                                        </span>
                                      </a>
                                    </div>

                                    {/* Other Options */}
                                    {Object.keys(item.customData)
                                      .filter(
                                        (key) =>
                                          key !== "Type" && key !== "Main",
                                      )
                                      .map((key) =>
                                        item.customData[key] &&
                                        item.customData[key].id ? (
                                          <div
                                            key={key}
                                            className="option-button-wrapper"
                                          >
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleOptionSelect(
                                                  item.id,
                                                  key,
                                                );
                                              }}
                                              className={`option-button ${
                                                optionKey === key
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              <span className="option-text">
                                                {key}
                                              </span>
                                            </a>
                                          </div>
                                        ) : null,
                                      )}
                                  </div>
                                )}

                              {/* description main container*/}
                              {/* <div className={`description-main ${isExpanded ? 'expanded' : ''}`}> */}

                              <div className="description-main">
                                {/* <button className="toggle-button gradient-text" onClick={() => toggleDescription(displayedProduct.id)}>
                                                            {isExpanded ? <IoIosArrowUp/> : <IoIosArrowDown/>}
                                                           </button> */}

                                <div className="description-div">
                                  {parse(
                                    displayedProduct.description
                                      ? displayedProduct.description
                                      : " ",
                                  )}
                                </div>

                                <div
                                  className={`specifications-div ${
                                    displayedProduct.specifications
                                      ? ""
                                      : "display-none"
                                  }`}
                                >
                                  {parse(
                                    displayedProduct.specifications
                                      ? displayedProduct.specifications
                                      : "",
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="btn-div cartbtn">
                              {cart[displayedProduct.id] ? (
                                <div
                                  className="primary-button-border-wrap"
                                  style={{ width: "100%", cursor: "pointer" }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removeFromCart(displayedProduct.id);
                                  }}
                                >
                                  <div className="inner-button-wrap">
                                    <div className="inner-button-text-wrap">
                                      <div className="inner-button-text">
                                        {t("removeFromCart")}
                                      </div>
                                      <div className="inner-button-hover-text">
                                        {t("removeFromCart")}
                                      </div>
                                    </div>
                                    <div className="inner-button-star-wrap">
                                      <img
                                        loading="lazy"
                                        src="/images/inner-button-star-1.svg"
                                        alt=""
                                        className="inner-button-star _1"
                                      />
                                      <img
                                        loading="lazy"
                                        src="/images/inner-button-star-2.svg"
                                        alt=""
                                        className="inner-button-star _2"
                                      />
                                      <img
                                        loading="lazy"
                                        src="/images/inner-button-star-3.svg"
                                        alt=""
                                        className="inner-button-star _3"
                                      />
                                    </div>
                                    <div className="inner-button-hover-bg"></div>
                                  </div>
                                </div>
                              ) : (
                                <div className="navbar-button-wrapper">
                                  <div className="primary-button-wrapper">
                                    <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleAddToCart(displayedProduct);
                                      }}
                                      data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                                      className="primary-button w-inline-block"
                                    >
                                      <div className="primary-button-border-wrap">
                                        <div className="primary-button-wrap">
                                          <div className="primary-button-text">
                                            {t("addToCart")}
                                          </div>
                                          <div className="primary-button-hover-text">
                                            {t("addToCart")}
                                          </div>
                                          <div className="primary-button-hover-bg"></div>
                                        </div>
                                      </div>
                                      <div className="line-wrap">
                                        <div className="primary-line-wrap _1">
                                          <div className="line _1"></div>
                                          <div className="line _2"></div>
                                        </div>
                                        <div className="primary-line-wrap _2">
                                          <div className="line _3"></div>
                                          <div className="line _4"></div>
                                        </div>
                                        <div className="primary-line-wrap _3">
                                          <div className="line _5"></div>
                                          <div className="line _6"></div>
                                        </div>
                                        <div className="primary-line-wrap _4">
                                          <div className="line _7"></div>
                                          <div className="line _8"></div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </Slider>
                )}
              </>
            ) : (
              <>
                <div className="error-card">
                  <p className="error-text">{t("ProductNotAvailable")}</p>
                </div>
              </>
            )}
          </div>

          <div className="card-footer-button-wrapper">
            <div></div>
            {totalItemsInCart > 0 && (
              <div className="navbar-button-wrapper">
                <div className="primary-button-wrapper">
                  <a
                    href="#"
                    onKeyDown={(e) => {
                      checkKeyPress();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      fnNavigate();
                    }}
                    data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                    className="primary-button w-inline-block"
                  >
                    <div className="primary-button-border-wrap">
                      <div className="primary-button-wrap">
                        <div className="primary-button-text">
                          {addOnItems && addOnItems.length > 0
                            ? t("Add On")
                            : t("proceedToCheckout")}
                        </div>
                        <div className="primary-button-hover-text">
                          {addOnItems && addOnItems.length > 0
                            ? t("Add On")
                            : t("proceedToCheckout")}
                        </div>
                        <div className="primary-button-hover-bg"></div>
                      </div>
                    </div>
                    <div className="line-wrap">
                      <div className="primary-line-wrap _1">
                        <div className="line _1"></div>
                        <div className="line _2"></div>
                      </div>
                      <div className="primary-line-wrap _2">
                        <div className="line _3"></div>
                        <div className="line _4"></div>
                      </div>
                      <div className="primary-line-wrap _3">
                        <div className="line _5"></div>
                        <div className="line _6"></div>
                      </div>
                      <div className="primary-line-wrap _4">
                        <div className="line _7"></div>
                        <div className="line _8"></div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
